<template>
  <div class="container-fluid">
    <notifications></notifications>

    <div class="login">
      <div class="card text-center p-sm-5 p-3" style="width: 25rem;">
        <h5 class="card-title">
          <img src="/assets/logo/logo_white.svg" alt="" />
        </h5>

        <div class="card-body">
          <form class="mt-3" @submit.prevent="login" action="#">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Gebruikersnaam"
                v-model="form.username"
              />
              <p v-if="this.error" class=" text-danger mt-2">
                {{ this.error_msg }}
              </p>
            </div>
            <div class="form-group mt-4">
              <input
                type="password"
                class="form-control"
                placeholder="Wachtwoord"
                v-model="form.password"
              />
            </div>
            <div
              v-for="(notif, index) in notifications.danger"
              :key="index"
              class=""
            >
              <p class="m-0 p-0 text-danger">{{ notif.message }}</p>
            </div>
            <div class="form-group mt-4 text-white">
              <router-link class="text-white" to="/forgot-password">
                Wachtwoord en/of gebruikersnaam vergeten?</router-link
              >
            </div>
            <div class="form-group ">
              <button type="submit" class="btn btn-dark mt-4">
                <loader></loader><span v-if="!this.loader">Inloggen</span>
              </button>
            </div>
            <router-link
              to="/register"
              class="text-white"
              v-if="public_register"
              >Registreer</router-link
            >
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import loader from "../helper/loader";
import { mapActions, mapState } from "vuex";
import Notifications from "../helper/notifications";

export default {
  name: "login",
  components: { Notifications, loader },
  data() {
    return {
      form: {
        username: process.env.VUE_APP_USERNAME,
        password: process.env.VUE_APP_PASSWORD,
      },
      error: false,
      error_msg: "",
      public_register: process.env.VUE_APP_ALLOW_PUBLIC_REGISTER,
    };
  },
  computed: {
    ...mapState({
      notifications: (state) => state.auth.notifications,
      loader: (state) => state.auth.loader,
      user: (state) => state.auth.user,
      showForgotPassword: (state) => state.auth.showForgotPassword,
    }),
  },
  methods: {
    ...mapActions({
      signIn: "auth/signIn",
    }),

    async login() {
      this.error = false;
      this.$store.state.auth.user = null;
      if (
        this.form.username.trim().length == 0 ||
        this.form.password.trim().length == 0
      ) {
        this.error = true;
        this.error_msg = "vul gebruikersnaam en wachtwoord";
        return false;
      }
      await this.signIn(this.form);
      setTimeout(() => {
        console.log(this.showForgotPassword);
      }, 4000);

      if (this.user) {
        if (
          this.user.privacy_settings == null ||
          this.user.privacy_settings == ""
        ) {
          this.$swal({
            title: "Privacy instellingen",
            text:
              "Het lijkt erop dat je privacy instellingen nog niet hebt ingesteld. Klik op de button om dit alsnog te doen.",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Aanpassen",
            cancelButtonText: "Overslaan",
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.replace({
                name: "user.privacy",
                params: { id: this.user.id },
              });
            } else if (result.isDismissed) {
              this.$router.replace({ name: "home" });
            }
          });
        } else {
          this.$router.replace({ name: "home" });
        }
      }
    },
  },
};
</script>

<style scoped>
.swal2-actions {
  width: 100% !important;
  justify-content: space-between !important;
}
.container-fluid {
  height: 100vh;
  background: transparent linear-gradient(270deg, #73afe3 0%, #cfe4f6 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}

.login {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 20px;
  opacity: 1;
}

.form-control {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  height: calc(1.5em + 0.75rem + 8px) !important;
  font-size: 15px !important;
}

.text-white {
  font-size: 15px !important;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 15%;
  padding-right: 15%;
  font-size: 18px !important;
}
</style>
